import { Injectable } from "@angular/core";
import { UrlConnectionEnum } from "../../enums/url-connection.enum";
import { HttpService } from "../http-service/http.service";
import { SignUpModel } from "../../models/sing-up.model";

@Injectable({
    providedIn: 'root'   // ou no módulo que importa este serviço
})
export class SignUpService {

    constructor(private httpService: HttpService) { }

    /**
     * Signs in
     * @author Starley Cazorla
     * @param url
     * @param signUp
     * @returns
     */
    async signUp(signUp: SignUpModel) {
        return new Promise((resolve, reject) => {
            const config = this.httpService.setHeaderConfig(false);

            this.httpService.post(UrlConnectionEnum.SIGN_UP, signUp, config).subscribe({
                next: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(err);
                }
            });


        });
    }

}
